import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import MuiSelect from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import { toKebabCase } from '../../../utils';
import { ListSubheader } from '@mui/material';
export const SelectInput = ({ autoFocus = false, autoWidth = false, className = undefined, color = 'primary', fullWidth = false, helperText = undefined, isDisabled = false, hasError = false, isRequired = false, label, onChange = undefined, onOpen: onOpenProp = undefined, options, defaultOption = undefined, selectRef = null, shouldHideLabel = false, size = 'medium', variant = 'outlined', initialValue = '', isAlphanumeric = false, ...muiProps }) => {
    const [selectedValue, setSelectedValue] = useState(initialValue);
    useEffect(() => {
        setSelectedValue(initialValue);
    }, [initialValue]);
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        if (onChange) {
            onChange(event, label);
        }
    };
    const handleOpen = () => {
        onOpenProp?.();
    };
    const id = toKebabCase(label);
    const groupedOptions = options.reduce((acc, option) => {
        const { group = '' } = option;
        if (!acc[group]) {
            acc[group] = [];
        }
        acc[group].push(option);
        return acc;
    }, { '': [] });
    const ungroupedOptions = groupedOptions[''];
    delete groupedOptions[''];
    const sortOptions = ({ label: a }, { label: b }) => {
        if (!isAlphanumeric || a === b) {
            return 0;
        }
        return a < b ? -1 : 1;
    };
    return (_jsxs(FormControl, { className: className, color: color, disabled: isDisabled, error: hasError, fullWidth: fullWidth, required: isRequired, size: size, variant: variant, children: [!shouldHideLabel && (_jsx(InputLabel, { id: `${id}-label`, children: label })), _jsxs(MuiSelect, { autoFocus: autoFocus, autoWidth: autoWidth, displayEmpty: shouldHideLabel, id: id, inputProps: shouldHideLabel ?
                    { 'aria-label': label } :
                    {}, label: !shouldHideLabel ? label : null, labelId: `${id}-label`, onChange: handleChange, onOpen: handleOpen, ref: selectRef, value: selectedValue, ...muiProps, children: [defaultOption && (_jsx(MenuItem, { value: "", children: defaultOption })), ungroupedOptions.map(option => (_jsx(MenuItem, { value: option.value, children: option.label }, option.value.toString()))), Object.entries(groupedOptions).map(([groupName, groupOptions]) => {
                        return [
                            _jsx(ListSubheader, { children: groupName }, `group-${groupName}`),
                            ...groupOptions.sort(sortOptions).map(option => (_jsx(MenuItem, { value: option.value, children: option.label }, option.value.toString())))
                        ];
                    })] }), helperText &&
                _jsx(FormHelperText, { children: helperText })] }));
};
export default SelectInput;
//# sourceMappingURL=index.js.map